<template>
  <component
    :is="compiledData"
    :code="code"
  />
</template>

<script>

import ChangeLogPreviewBtn from './ChangeLogPreviewBtn';

export default {
  name: 'ChangeLogDelta',
  components: {
    ChangeLogPreviewBtn
  },
  props:{
    changes: {
      type: Array,
      default: function() {
        return {};
      }
    },    
    code: {
      type: [Object, String],
      default: function() {
        return {};
      }
    }
  },
  computed: {
    compiledData () {
      return {
        template: this.changes.join(''),
        components: { ChangeLogPreviewBtn },
        data() {
          return {    
            hideDetails: true
          };
        },
        props: {
          code: {
            type: [Object, String],
            default: function() {
              return {};
            }
          }
        }
      };
    }
  }
};
</script>
